// @flow

import React from 'react';

import { base } from 'app/developer-v3/components/PartnerSupportForm/utils/tree';

import type { NodeDefinition } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';

import Topic from './Topic';
import { type NodeOptions } from './types';

const topic = (options: NodeOptions): NodeDefinition => {
  const children = {};
  const items = [];

  options.items.forEach(({ child, ...item }) => {
    items.push(item);
    children[item.value] = child;
  });

  const node = base({
    id: 'topic',
    children,
    isDataValid: data => {
      return !!node.getNextNode(data, {});
    },
    getNextNode: data => {
      return typeof data === 'string' ? node.children[data] : null;
    },
    render: props => {
      return <Topic {...props} items={items} label={options.label} />;
    },
    export: data => ({
      id: node.id,
      data,
      label: options.label,
      zendeskCustomFieldId: options.zendeskCustomFieldId,
      // find the correct child item from items and then
      // access `zendeskCustomFieldValue` from that item.
      // Default to empty object if items.find(...) is a miss
      // to avoid a syntax error.
      zendeskCustomFieldValue:
        data &&
        (items.find(({ value }) => value === data) || {})
          .zendeskCustomFieldValue,
      formatted:
        data && (items.find(({ value }) => value === data) || {}).label,
    }),
  });

  return node;
};

export default topic;
